<template>
  <div>
    <b-skeleton-wrapper :loading="loadingFilter">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
      <Filters :elements="filterElements" @selectedFilters="selectedFilters" />
    </b-skeleton-wrapper>

    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="handleRowClick"
      :moduleName="`account.support`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
      :showFilterClearButton="true"
      @clearFilter="clearFilter"
      :moduleSearch="search"
      class="support-list"
    >
      <template v-slot:header.id>
        <b-dropdown class="dropdown-detail" no-caret right>
          <template #button-content>
            <i class="fad fa-search"></i> {{ $t('account.ticketNumber') }}
          </template>
          <b-dropdown-text>
            <div class="form-search-input">
              <v-text-field
                class="my-0 font-size-sm"
                :placeholder="$t('account.searchForTicketNumber')"
                prepend-icon="search"
                v-model="searchId"
                single-line
                dense
                flat
                solo
                hide-details
              ></v-text-field>
            </div>
          </b-dropdown-text>
        </b-dropdown>
      </template>

      <template v-slot:item.priority="{ item }">
        {{ $t('filters.' + item.priority.toLowerCase()) }}
        <span
          class="priority"
          :inner-html.prop="item.priority | filterPriority"
        ></span>
      </template>

      <template v-slot:item.created_at="{ item }">
        {{
          $customFunctions.setMomentWithFormat(
            item.created_at,
            'DD.MM.YYYY HH:mm'
          )
        }}
      </template>

      <template v-slot:item.category="{ item }">
        {{
          item.category && item.category.data && item.category.data.name
            ? item.category.data.name
            : 'N/A'
        }}
      </template>

      <template v-slot:item.status="{ item }">
        <b-badge
          class="rounded-sm"
          :class="'badge-' + item.status.toLowerCase()"
          >{{ $t('filters.' + item.status.toLowerCase()) }}</b-badge
        >
      </template>

      <template v-slot:item.action="{ item }">
        <ActionButton
          icon="fas fa-eye"
          :title="`${$t('global.detail')}`"
          @click.native="handleRowClick(item)"
        ></ActionButton>

        <GreenButton
          icon="fad fa-check"
          :title="$t('global.delete')"
          class="ml-2"
          @click.native="openDeleteHandler(item)"
        ></GreenButton>
      </template>
    </List>

    <!-- Create Popup -->
    <DetailModal
      :title="$t('account.newSupportTicket')"
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <SupportForm
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
      />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />

    <SupportAnswerModal :ticket="selectedTicket" @getTickets="getList" />

    <!--end::Support-->

    <div class="page-content-loading" v-if="pageContentLoading">
      <span class="spinner spinner-light spinner-center"></span>
    </div>
  </div>
</template>

<script>
//Services
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

var getTicketsInterval

export default {
  name: 'Support',
  data() {
    return {
      loading: false,
      loadingFilter: false,
      pageContentLoading: false,
      showDetail: false,
      resetPage: false,
      search: '',
      searchId: '',
      filters: '',
      filterElements: [],
      header: [
        { text: 'global.priority', value: 'priority', size: '100px' },
        { text: 'account.ticketNumber', value: 'id', size: '150px' },
        { text: 'global.title', value: 'title' },
        { text: 'global.category', value: 'category' },
        { text: 'global.createDate', value: 'created_at', size: '160px' },
        { text: 'global.status', value: 'status', size: '100px' },
        { text: 'global.actions', value: 'action', size: '100px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      itemsCount: 0,
      selectedTicket: '',
      confirmCreate: false,
      resetForm: false,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'account.support',
        route: '/support',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'account.support',
        },
      ],
      searchPlaceholder: 'account.searchSupportTicket',
      detailPlaceholder: 'account.newSupportTicket',
    })

    EventBus.$on(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$on(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  created() {
    this.setFilters()
    this.getList()
    this.startTicketInterval('created')

    if (this.$route.hash) {
      // Clear answer modal
      this.$bvModal.hide('answer-modal')
      // Get Ticket
      this.getTicketID(this.$route.hash)
    }
  },
  destroyed() {
    clearInterval(getTicketsInterval)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$off(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  methods: {
    listenersubHeaderSearch(payload) {
      this.search = payload
      this.resetPage = true
      this.getList()
    },
    listenersubHeaderDetailOpen(payload) {
      this.showDetail = payload
    },
    setFilters() {
      this.filterElements = [
        {
          type: 'button',
          name: 'status',
          value: 'all',
          items: [
            { name: 'filters.all', value: 'all' },
            { name: 'filters.open', value: 'open' },
            { name: 'filters.pending', value: 'pending' },
            { name: 'filters.closed', value: 'closed' },
          ],
        },
        {
          type: 'dropdown',
          name: 'priorities',
          value: 'all',
          items: [
            { name: 'filters.allPriorities', value: 'all' },
            { name: 'filters.low', value: 'low' },
            { name: 'filters.medium', value: 'medium' },
            { name: 'filters.high', value: 'high' },
          ],
        },
      ]
      this.categories()
    },
    categories() {
      this.getCategories()
        .then((res) => {
          this.setCategories(res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCategories() {
      this.loadingFilter = true
      return new Promise((resolve, reject) => {
        ApiService.get('categories')
          .then(({ data }) => {
            this.loadingFilter = false
            resolve(data)
          })
          .catch((err) => {
            this.loadingFilter = false
            reject(err)
          })
      })
    },
    setCategories(res) {
      let _categoryItems = [{ name: 'filters.allCategories', value: '' }]

      res.data.forEach((element) => {
        _categoryItems.push({
          name: element.name,
          value: element.id,
          isDynamicName: 'false',
        })

        if (element.children)
          element.children.forEach((childElement) => {
            _categoryItems.push({
              name: childElement.name,
              value: childElement.id,
              class: 'small pl-3',
              isDynamicName: 'false',
            })
          })
      })

      let _categoryFilter = {
        type: 'dropdown',
        name: 'category',
        value: '',
        items: _categoryItems,
      }

      this.filterElements.push(_categoryFilter)
    },
    selectedFilters(value) {
      this.filters = value
      this.resetPage = true
      this.getList()
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta
      let selectedPage = current_page ? current_page : 1
      if (this.resetPage) {
        selectedPage = 1
        this.resetPage = false
      }

      let $query = `support?page=${selectedPage}`

      if (this.search) $query += `&title=${this.search}`

      if (this.filters) $query += `&${this.filters}`

      if (this.searchId) $query += `&id=${this.searchId}`

      if ($query.includes('position=') == false) $query += `&position=id|desc`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          // console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    handleRowClick(item) {
      this.selectedTicket = item
      this.$bvModal.show('answer-modal')
    },
    closeDetail() {
      this.selectedTicket = ''
      this.showDetail = false
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `support/${item.id}/solved`
      this.$bvModal.show('modal-deleteOperation')
    },
    clearFilter() {
      EventBus.$emit('clearSearch', '')
      this.search = ''
      this.searchId = ''
      this.resetPage = true
      this.setFilters()
      this.filters = ''
      this.getList()
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.clearFilter()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    startTicketInterval(whereStart) {
      getTicketsInterval = setInterval(() => {
        ApiService.get('support').then(({ data }) => {
          // SetInterval first request and set itemsCount
          if (whereStart == 'created') {
            whereStart = ''
            this.itemsCount = data.meta.pagination.total
          }

          // Check tickets count
          if (
            this.itemsCount > 0 &&
            data.meta.pagination.total > this.itemsCount
          ) {
            // Show New ticket available alert
            this.$generateToast(
              this,
              'success',
              this.$t('account.newTicketAlert')
            )

            // Get new tickets
            this.getList()

            // Set up to date itemsCount
            this.itemsCount = data.meta.pagination.total
          }
        })
      }, 60000) // 1 minute
    },
    getTicketID(toHash) {
      this.pageContentLoading = true

      if (toHash.charAt(0) == '#') {
        ApiService.get(`support/${toHash.substring(1)}`)
          .then(({ data }) => {
            this.selectedTicket = data.data
            this.$bvModal.show('answer-modal')

            this.pageContentLoading = false
          })
          .catch((err) => {
            console.error(err)
            this.pageContentLoading = false
          })
      }
    },
  },
  filters: {
    filterPriority(priority) {
      switch (priority) {
        case 'LOW':
          return '<i class="fas fa-arrow-down"></i>'
        case 'HIGH':
          return '<i class="fas fa-arrow-up"></i>'
        default:
          return '<i class="fas fa-minus"></i>'
      }
    },
    titleCase(str) {
      return str
        .split(' ')
        .map(
          (item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
        )
        .join(' ')
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
    searchId: function () {
      this.resetPage = true
      this.getList()
    },
    $route(to) {
      if (to.hash) {
        // Clear answer modal
        this.$bvModal.hide('answer-modal')
        // Get Ticket
        this.getTicketID(to.hash)
      }
    },
  },
  components: {
    SupportForm: () => import('@/components/account/forms/SupportForm'),
    SupportAnswerModal: () =>
      import('@/components/account/forms/SupportAnswerModal'),
  },
}
</script>

<style lang="scss">
.support-list {
  .dropdown-detail {
    button {
      padding: 0;
      margin: 0;
      background: none !important;
      border: none;
      font-size: 12px;
      line-height: 18px;
      font-weight: 600;
      letter-spacing: 0.03em;
      color: #b5b5c3;
    }
    ul {
      width: 250px !important;
    }
    .form-search-input,
    .v-input__slot,
    input {
      background: #fff !important;
    }
    .form-search-input {
      padding-left: 0px !important;
    }
  }
}
</style>
